import { router } from '@/lib/router.tsx';
import { queryClient } from '@/lib/queryClient.ts';

export function redirectToLogin() {
  if (router.state.location.pathname === '/login') {
    return null;
  }
  queryClient.clear();
  const redirectUri = window.location.pathname + window.location.search;
  return router.navigate({ to: '/login', search: { redirectUri } });
}
